import React, { useContext } from 'react';
import { Navigate } from 'react-router';
import AuthContext from '../context/AuthContext';
import './UserProfile.css';

const UserProfile = () => {
    const { auth } = useContext(AuthContext);

    if (!auth.token) {
        return <Navigate to="/login" />;
    }

    return (
        <div className="profile-container">
            <div className="profile-card">
                <div className='profile-header'>
                    <div className='profile-avatar-large'>
                        {auth.user?.name ? auth.user.name.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <h2>{auth.user?.name}</h2>
                    <p className='profiile-role'>Traveller</p>
                </div>

                <div className='profile-details'>
                    <h3>Account Information</h3>
                    <div className='detail-row'>
                        <span className='detail-label'>Email:</span>
                        <span className='detail-value'>{auth.user?.email}</span>
                    </div>
                    <div className='detail-row'>
                        <span className='detail-label'>User ID:</span>
                        <span className='detail-value'>{auth.user?._id}</span>
                    </div>
                    <div className='detail-row'>
                        <span className='detail-label'>Your Points:</span>
                        <span className='detail-value'>{auth.user?.points}</span>
                    </div>
                </div>

                <div className='profile-actions'>
                    <button className='action-btn secondary' onClick={() => alert('Funkcja zmiany hasla bedzie dostepna wkrotce!')}>
                        Change Password
                    </button>
                    <button className='action-btn secondary' onClick={() => alert('Historia zakupow bedzie dostepna wkrotce!')}>
                        Purchase History
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;